var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgForUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 452.986 452.986",
    xmlSpace: "preserve",
    width: "64px",
    height: "64px",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00000064"
    },
    d: "M403.87,0H49.095C22.11,0,0,22.11,0,49.117v354.796c0,26.963,22.11,49.074,49.095,49.074H403.87 c27.007,0,49.117-22.11,49.117-49.074V49.117C452.986,22.11,430.876,0,403.87,0z M415.82,410.859H37.188V101.836H415.82V410.859z "
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#00000064"
    },
    cx: 124.765,
    cy: 169.029,
    r: 36.843
  }), /*#__PURE__*/React.createElement("rect", {
    x: 192.282,
    y: 153.692,
    style: {
      fill: "#00000064"
    },
    width: 161.716,
    height: 30.695
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#00000064"
    },
    cx: 124.765,
    cy: 259.065,
    r: 36.843
  }), /*#__PURE__*/React.createElement("rect", {
    x: 192.282,
    y: 243.728,
    style: {
      fill: "#00000064"
    },
    width: 161.716,
    height: 30.674
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#00000064"
    },
    cx: 124.765,
    cy: 349.123,
    r: 36.843
  }), /*#__PURE__*/React.createElement("rect", {
    x: 192.282,
    y: 333.765,
    style: {
      fill: "#00000064"
    },
    width: 161.716,
    height: 30.674
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", null)), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", null)))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForUser);
export default __webpack_public_path__ + "static/media/for_user.62e328a81ff3ddd7a51beae6a2fcc38e.svg";
export { ForwardRef as ReactComponent };